import { ref } from 'vue';
import {
  resolvePostalCodeSearchProvider,
  type PostalCodeSearchOutcome,
} from '@/composables/postalCodeProvider';

export interface PostalCodeOption {
  code: string;
  location: string;
  state: string;
  city: string;
  displayValue: string;
  /** Host RM: true demo catalog, false Chubb/real. Omit on legacy. */
  mock?: boolean;
  idEstado?: number;
  idCiudad?: number;
  idMunicipio?: number;
}

export type { PostalCodeSearchOutcome };

export const usePostalCode = () => {
  const postalCode = ref('');
  const postalCodeDisplay = ref('');

  /**
   * Element Plus autocomplete callback (legacy shape).
   * Prefer `searchPostalCodesDetailed` when UI needs empty/error differentiation.
   */
  const searchPostalCodes = async (
    queryString: string,
    cb: (results: PostalCodeOption[]) => void,
  ): Promise<void> => {
    const outcome = await searchPostalCodesDetailed(queryString);
    cb(outcome.items);
  };

  const searchPostalCodesDetailed = async (
    queryString: string,
    options?: { signal?: AbortSignal },
  ): Promise<PostalCodeSearchOutcome> => {
    if (!queryString || queryString.length < 2) {
      return { status: 'empty', items: [], message: undefined };
    }

    const provider = resolvePostalCodeSearchProvider();
    return provider(queryString, options);
  };

  const handlePostalCodeSelect = (item: PostalCodeOption): void => {
    postalCode.value = item.code;
    postalCodeDisplay.value = item.displayValue;
  };

  const handlePostalCodeClear = (): void => {
    postalCode.value = '';
    postalCodeDisplay.value = '';
  };

  return {
    postalCode,
    postalCodeDisplay,
    searchPostalCodes,
    searchPostalCodesDetailed,
    handlePostalCodeSelect,
    handlePostalCodeClear,
  };
};
